import { render, staticRenderFns } from "./across_third.vue?vue&type=template&id=33d68848&scoped=true"
import script from "./across_third.vue?vue&type=script&lang=js"
export * from "./across_third.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d68848",
  null
  
)

export default component.exports